<template>
    <div class="screen-layout">
        <slot />
    </div>
</template>

<style lang="less">
/*
* Each screen fills the whole viewport on a black background.
*/
html,
body,
#__nuxt {
    margin: 0;
    padding: 0;
    height: 100%;
    background: #000;
}

.screen-layout {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100dvh;
    overflow: hidden;
    background: #000;
    user-select: none;
}
</style>
